export const SET_TEMPERATURE = 'SET_TEMPERATURE';
export const SET_IS_PAUSED = 'SET_IS_PAUSED';
export const SET_IS_MICROSCOPIC = 'SET_IS_MICROSCOPIC';
export const SET_SHOW_THERMOMETER_LABELS = 'SET_SHOW_THERMOMETER_LABELS';
export const SET_SHOW_GRID = 'SET_SHOW_GRID';
export const SET_SHOW_EMITTED_LINES = 'SET_SHOW_EMITTED_LINES';
export const RESET_SETTINGS = 'RESET_SETTINGS';
export const TOGGLE_ELECTRONS = 'TOGGLE_ELECTRONS';
export const TOGGLE_WAVELENGTH_DISTRIBUTION = 'TOGGLE_WAVELENGTH_DISTRIBUTION';
export const SET_SCALE_UNIT = 'SET_SCALE_UNIT';
